import { useState } from "react";
import { galleryByCategory } from "../data/mock";
import { X } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";

export const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const categories = Object.keys(galleryByCategory);

  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-crimson-600">Work Gallery</span>
          </h2>
          <p className="text-lg text-gray-600">
            Browse our completed projects by service category. Quality craftsmanship and attention to detail in every job.
          </p>
        </div>

        {/* Gallery Tabs by Category */}
        <Tabs defaultValue={categories[0]} className="w-full">
          <TabsList className="grid w-full grid-cols-2 md:grid-cols-3 lg:grid-cols-5 h-auto mb-12 bg-gray-100 p-2 rounded-lg">
            {categories.map((category) => (
              <TabsTrigger 
                key={category} 
                value={category}
                className="text-sm md:text-base py-3 data-[state=active]:bg-crimson-600 data-[state=active]:text-white"
              >
                {category}
              </TabsTrigger>
            ))}
          </TabsList>

          {categories.map((category) => (
            <TabsContent key={category} value={category} className="mt-0">
              <div className={`${
                galleryByCategory[category].length === 1 
                  ? 'flex justify-center' 
                  : galleryByCategory[category].length === 2
                  ? 'flex justify-center gap-6 flex-wrap'
                  : 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'
              }`}>
                {galleryByCategory[category].map((image, index) => (
                  <div 
                    key={`${category}-${image}-${index}`}
                    className={`relative group cursor-pointer overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 ${
                      galleryByCategory[category].length === 1 
                        ? 'max-w-2xl w-full' 
                        : galleryByCategory[category].length === 2
                        ? 'max-w-md w-full'
                        : ''
                    }`}
                    onClick={() => setSelectedImage(image)}
                  >
                    <img 
                      src={image} 
                      alt={`${category} - Project ${index + 1}`} 
                      className={`w-full object-cover transform group-hover:scale-110 transition-transform duration-500 ${galleryByCategory[category].length === 1 ? 'h-96' : 'h-80'}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-4 left-4 right-4">
                        <p className="text-white font-semibold text-lg">{category}</p>
                        <p className="text-white/90 text-sm">Click to view</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </TabsContent>
          ))}
        </Tabs>

        {/* Lightbox Modal */}
        {selectedImage && (
          <div 
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <button
              className="absolute top-4 right-4 text-white hover:text-crimson-600 transition-colors"
              onClick={() => setSelectedImage(null)}
            >
              <X className="w-8 h-8" />
            </button>
            <img 
              src={selectedImage} 
              alt="Project detail" 
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>
    </section>
  );
};
